import React, { Component } from 'react';
import { Row, Col, Panel, Button } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import Dropzone from 'react-dropzone';

const styles = {
  imagesList: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    overflow: 'auto'
  },
  imageWrapper: {
    position: 'relative',
    width: '100px',
    height: '100px',
    marginRight: '5px',
    marginBottom: '5px'
  },
  image: {
    width: '100px',
    height: '100px'
  },
  removeBtn: {
    position: 'absolute',
    right: '5px',
    top: '0px',
    color: 'red',
    fontWeight: '500',
    fontSize: '18px'
  },
  dropzone: {
    width: '100px',
    height: '100px',
    border: '1px solid #BBBBBB',
    fontSize: '20px',
    color: '#BBBBBB',
    textAlign: 'center',
    lineHeight: '100px'
  }
}
class GroupImageManageModal extends Component {
  constructor(props) {
    super();
    this.state = {
      row: props.row
    }
  }

  componentWillReceiveProps(nextProps) {
    console.log(nextProps, 'nextProps')
    if(nextProps.row) {
      this.setState({
        row: nextProps.row
      })
    }
  }
  
  handleDelete = (index) => {
    this.state.row.GroupImage.splice(index, 1);
    this.setState({
      row: {...this.state.row, GroupImage: this.state.row.GroupImage}
    })
  }
  
  handleDrop = (files) => {
    for(let i = 0; i < files.length; i++) {
      const reader = new FileReader();
      reader.onload = () => {
        this.state.row.GroupImage.push(reader.result);
        this.setState({
          row: {...this.state.row, GroupImage: this.state.row.GroupImage}
        })
      };
      const blob = files[i].slice(0, files[i].size, files[i].type);
      reader.readAsDataURL(blob);
    }
  }
  
  handleSaveButtonClick = () => {
    this.props.onConfirm(this.state.row);
  }
  
  render() {
    return (
      <div style={{height: '85%'}}>
        <Panel style={{height: '90%'}}>
          <Row>
            <Col xs={12}>
              <div style={styles.imagesList}>
                {this.state.row.GroupImage.map((Image, index) => <div style={{...styles.imageWrapper, marginLeft: '0px', marginTop: '0px'}} key={index}>
                  <div style={styles.removeBtn} onClick={() => this.handleDelete(index)}><em className="fa fa-close" /></div>
                  <div style={styles.image}>
                    <img style={styles.image} src={Image} alt=""/>
                  </div>
                </div>)}
                <Dropzone
                  onDrop={this.handleDrop}
                  className="image-dropzone"
                  accept="image/*"
                >
                  <div style={styles.dropzone}><em className="fa fa-plus" /></div>
                </Dropzone>
              </div>
            </Col>
          </Row>
        </Panel>
        <Button
          bsStyle="success"
          className="buttonStyle"
          onClick={this.handleSaveButtonClick}
          style={{ float: 'right' }}
        >
          <em className="fa fa-save marginRightStyle" /><Translate value="confirm" />
        </Button>
      </div>
    )
  }
}

export default GroupImageManageModal;


// WEBPACK FOOTER //
// ./master/jsx/components/Products/components/GroupImageManageModal.jsx